import React from 'react';
import { Icon } from '@chakra-ui/react';

export const ChakraCloseIcon = (props) => {
  return (
    <Icon width="9" height="9" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" cursor="pointer" {...props}>
      <circle cx="18" cy="18" r="18" fill="#F5F5F5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.286 14.4646L16.8215 18.0001L13.286 21.5357C12.9605 21.8611 12.9605 22.3887 13.286 22.7142C13.6114 23.0396 14.139 23.0396 14.4645 22.7142L18 19.1786L21.5355 22.7142C21.861 23.0396 22.3886 23.0396 22.714 22.7142C23.0395 22.3887 23.0395 21.8611 22.714 21.5357L19.1785 18.0001L22.714 14.4646C23.0395 14.1392 23.0395 13.6115 22.714 13.2861C22.3886 12.9607 21.861 12.9607 21.5355 13.2861L18 16.8216L14.4645 13.2861C14.139 12.9607 13.6114 12.9607 13.286 13.2861C12.9605 13.6115 12.9605 14.1392 13.286 14.4646Z"
        fill="#1B2221"
      />
    </Icon>
  );
};
